// Shared translations for the AccessEmailSettingsPanel (SMTP sender + email templates).
// Consumers: mQmarketing (AdminAccessEmailSettingsSection), mQguard (AdminPage).
// my-vitalteam does NOT consume this component, so only de/en are provided.
//
// Conflict resolution:
// - Casing: mQguard used Title Case in English; the neutral, clearer mQmarketing
//   sentence-case variant is taken as the shared default.
// - Template labels (subject/body): mQguard used activation-/reset-email specific
//   wording; the more neutral mQmarketing "Invitation"/"Password reset" wording is
//   taken as the shared default.
// - "Show password" / "Hide password" are intentionally NOT defined here: both
//   consuming apps also merge sharedAdmin (adminTranslations.ts), which already
//   defines those keys. Defining them here as well would duplicate a key inside a
//   single app's merged translation map. They resolve via sharedAdmin instead.

export const sharedAccessEmailDe = {
  "Mail delivery account": "Versandkonto",
  "Sender email address": "Absenderadresse",
  "SenderEmailPlaceholder": "noreply@example.com",
  "Reply-to email address": "Antwortadresse",
  "ReplyToEmailPlaceholder": "support@example.com",
  "SMTP host": "SMTP-Server",
  "SmtpHostPlaceholder": "smtp.example.com",
  "SMTP port": "SMTP-Port",
  "SSL/TLS": "SSL/TLS",
  "SMTP user": "SMTP-Benutzer",
  "SmtpUserPlaceholder": "noreply@example.com",
  "SMTP password": "SMTP-Passwort",
  "Replace SMTP password": "SMTP-Passwort ersetzen",
  "PasswordMissingPlaceholder": "neues SMTP-Passwort eingeben",
  "SMTP password missing": "SMTP-Passwort fehlt.",
  "Save": "speichern",
  "Cancel": "abbrechen",
  "Send test email": "Test-E-Mail senden",
  "TestEmailRecipientPlaceholder": "Empfängeradresse für Test-E-Mail",
  "Send test": "Test senden",
  "Email templates": "E-Mail-Vorlagen",
  "Template language": "Vorlagensprache",
  "All languages": "alle Sprachen",
  "Delete": "löschen",
  "Password reset subject": "Betreff Passwort-Rücksetzung",
  "Password reset body": "Text Passwort-Rücksetzung",
  "Invitation subject": "Betreff Einladung",
  "Invitation body": "Text Einladung",
  "Add language": "Sprache hinzufügen",
  "Select language": "Sprache auswählen",
  "Add": "hinzufügen",
} as const;

export const sharedAccessEmailEn = {
  "Mail delivery account": "Delivery account",
  "Sender email address": "Sender email address",
  "SenderEmailPlaceholder": "noreply@example.com",
  "Reply-to email address": "Reply-to email address",
  "ReplyToEmailPlaceholder": "support@example.com",
  "SMTP host": "SMTP server",
  "SmtpHostPlaceholder": "smtp.example.com",
  "SMTP port": "SMTP port",
  "SSL/TLS": "SSL/TLS",
  "SMTP user": "SMTP user",
  "SmtpUserPlaceholder": "noreply@example.com",
  "SMTP password": "SMTP password",
  "Replace SMTP password": "Replace SMTP password",
  "PasswordMissingPlaceholder": "Enter new SMTP password",
  "SMTP password missing": "SMTP password is missing.",
  "Save": "Save",
  "Cancel": "Cancel",
  "Send test email": "Send test email",
  "TestEmailRecipientPlaceholder": "Recipient address for test email",
  "Send test": "Send test",
  "Email templates": "Email templates",
  "Template language": "Template language",
  "All languages": "All languages",
  "Delete": "Delete",
  "Password reset subject": "Password reset subject",
  "Password reset body": "Password reset body",
  "Invitation subject": "Invitation subject",
  "Invitation body": "Invitation body",
  "Add language": "Add language",
  "Select language": "Select language",
  "Add": "Add",
} as const;

export const sharedAccessEmailTranslations = {
  de: sharedAccessEmailDe,
  en: sharedAccessEmailEn,
} as const;

export type SharedAccessEmailLang = keyof typeof sharedAccessEmailTranslations;
export type SharedAccessEmailKey = keyof typeof sharedAccessEmailDe;
